<div bsModal
     #uploadDocumentModal="bs-modal"
     class="modal fade"
     tabindex="-1"
     role="dialog"
     aria-labelledby="myLargeModalLabel"
     aria-hidden="true">

    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">
                    <span>{{"UploadDocuments" | localize}}</span>
                </h5>
                <button type="button" class="close" [attr.aria-label]="l('Close')" (click)="close()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form id="loginAttemptsModalForm" class="form-horizontal">
                    <div class="form-body">
                        <div class="row">
                            <div class="col-12">
                                <div class="kt-portlet kt-portlet--mobile progress-section p-1">
                                    <div class="kt-widget24 progress-report">
                                        <div class="kt-widget24__item kt-portlet__nav-item text-center my-0 customfileupload">
                                            <p-fileUpload #fileUploadRef multiple="multiple" customUpload="true" id="DefaultFileUploadFileInput"
                                                          name="DefaultFileUploadFileInput[]" accept=".jpg,.jpeg,.png,.pdf,.xls,.xlsx,.doc,.docx,.xml"
                                                          maxFileSize="25000000" (uploadHandler)="DocumentUploader($event,fileUploadRef)"
                                                          [chooseLabel]="chooseLabel"
                                                          styleClass="customUpload"
                                                          uploadLabel="" uploadIcon="pi pi-check"
                                                          cancelLabel="" cancelIcon="pi pi-times">
                                            </p-fileUpload>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
          
        </div>
    </div>
</div>
